import AabSpinner from './AabSpinner.js';
import 'lit-element';
import '@open-wc/scoped-elements';
import 'lit-html/directives/unsafe-svg';

// This file is protected and will be overwritten by the @aab/cli

customElements.define('aab-spinner', AabSpinner);
